import { DESKTOP_MEDIA } from '@common/constants/MEDIAS';
import { css } from '@emotion/react';

import { palette } from '@lib/styles/palette';

export const memberDisputeWrapper = css`
  padding-top: 44px;
  ${DESKTOP_MEDIA} {
    padding-top: 0px;
  }
  line-height: normal;
  body {
    padding: 0;
    margin: 0;
    background: #e1e1e1;
    @extend %spoqa;
    font-size: 0;
    color: $black;
    box-sizing: border-box;
    position: relative;
    -webkit-text-size-adjust: none;
    -webkit-touch-callout: none;

    *,
    input,
    button {
      color: inherit;
      font-weight: inherit;
      box-sizing: border-box;
      letter-spacing: -0.3px;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      -webkit-tap-highlight-color: transparent;
      -webkit-text-size-adjust: none;
    }

    &.lockBody {
      height: 100vh;
      overflow: hidden;
    }
  }
  div {
    margin: unset;
    padding: unset;
    border: unset;
    vertical-align: unset;
  }
  ul,
  dl,
  dd,
  dt,
  ol,
  p {
    margin: 0;
    padding: 0;
    list-style: none;
  }
  p {
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
  }
  table tr,
  table th,
  table td {
    padding: 0;
    font-size: 0;
    text-align: left;
    box-sizing: border-box;
    vertical-align: middle;
    position: relative;
  }
  .page {
    width: 100vw !important;
    max-width: 750px !important;
    min-height: 100vh !important;
    background-color: #fff !important;
    margin: 0 auto !important;
  }
  .image-container {
    width: 100%;

    > div {
      position: unset !important;
    }

    .image {
      object-fit: contain;
      width: 100% !important;
      position: relative !important;
      height: unset !important;
    }
  }
  .memberDispute {
    letter-spacing: -0.6px !important;
    .content {
      max-width: 450px;
      margin: auto;

      .title {
        width: 283px;
      }

      .processWrap {
        position: relative;

        .circle {
          width: 28%;
          padding-top: 28%;
          border-radius: 50%;
          position: relative;

          &.solid {
            background: rgb(255, 108, 45);
            box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.2);
          }
          &.dotLine {
            border: 1px dotted rgb(255, 108, 45);
          }
          &.line {
            border: 1px solid rgb(255, 108, 45);
          }

          .text {
            display: inline-block;
            width: 100%;
            margin: auto;
            text-align: center;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
          svg {
            margin-top: 1px;
            margin-left: 2px;
            vertical-align: middle;
          }
        }
        .column {
          display: flex;
          align-items: center;
          .disc {
            flex: 1;
            text-align: center;
            .circleNum {
              display: inline-block;
              width: 13px;
              height: 13px;
              margin-right: 3px;
              background: rgb(255, 108, 45);
              border-radius: 50%;
              line-height: 13px;
              font-size: 10px;
              text-align: center;
              color: #fff;
            }
            .arrow {
              position: relative;
              &:before,
              &:after {
                content: '';
                width: 7px;
                height: 125px;
                margin: auto;
                background-image: url('https://common.joongna.com/image/dispute/DisputeArrow.png');
                background-position: center;
                background-size: auto 100%;
                background-repeat: no-repeat;
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                z-index: 0;
              }

              &.toRight {
                &:before {
                  transform: rotate(90deg);
                }
                &:after {
                  display: none;
                }
              }
              &.toLeft {
                &:before {
                  transform: rotate(270deg);
                }
                &:after {
                  display: none;
                }
              }
              &.toBottom {
                &:before {
                  transform: rotate(180deg);
                }
                &:after {
                  display: none;
                }
              }
              &.toBoth {
                &:before {
                  left: 20px;
                  transform: rotate(0deg);
                }
                &:after {
                  right: 20px;
                  transform: rotate(180deg);
                }
              }
            }
            .text {
              display: inline-block;
              padding: 0 2px;
              background: #fff;
              position: relative;
              z-index: 1;
            }
            .button {
              width: 111px;
              position: relative;
              z-index: 1;
            }
          }

          &.center {
            justify-content: space-between;
            .disc {
              max-width: 28%;
              padding: 5px 0;

              .arrow {
                display: flex;
                justify-content: center;
                flex-direction: column;
                min-height: 125px;
              }
            }
          }
        }
      }
      .step {
        .box {
          display: flex;
          align-items: center;
          padding: 25px;
          margin-top: 10px;
          background: rgb(255, 242, 236);
          border: 1px solid rgb(255, 227, 214);
          &:first-child {
            margin-top: 0;
          }

          .number {
            min-width: 20px;
            color: rgb(255, 150, 111);
          }
        }
      }
    }
  }
  .termsTable {
    width: 100%;
    border: 1px #ddd solid;
    border-collapse: collapse;

    tbody {
      background-color: #e9e9e9;
    }

    td,
    th {
      position: relative;
      padding: 16px 5px;
      border: 1px #ddd solid;
      font-size: 13px;
      vertical-align: top;

      span {
        position: absolute;
        top: 16px;
        left: 10px;
      }
    }

    th {
      text-align: center;
    }

    .th_1 {
      width: 110px;
    }

    .w25 {
      width: 25%;
    }
    .w35 {
      width: 35%;
    }
    .w40 {
      width: 40%;
    }
  }

  .pd_t40 {
    padding-top: 40px;
  }
  .pd_t30 {
    padding-top: 30px;
  }
  .pd_l22 {
    padding-left: 22px !important;
  }
  .pd_h20 {
    padding-left: 20px;
    padding-right: 20px;
  }
  .align_c {
    text-align: center;
  }
  .pd_b30 {
    padding-bottom: 30px;
  }

  .button {
    display: inline-block;
    padding: 0;
    margin: 0;
    background: none;
    border: none;
    border-radius: 0;
    outline: none;
    font-size: 0;
    text-align: center;
    vertical-align: middle;
    -webkit-appearance: none;
  }

  img {
    width: 100%;
    height: auto;
    max-width: 100%;
  }
  .f18 {
    font-size: 18px !important;
  }
  .f16 {
    font-size: 16px !important;
  }
  .f15 {
    font-size: 15px !important;
  }
  .f14 {
    font-size: 14px !important;
  }
  .f12 {
    font-size: 12px !important;
  }
  .f11 {
    font-size: 11px !important;
  }
  .bold {
    font-weight: 700;
  }
  .c_orange {
    color: #ff6900 !important;
  }
  strong {
    font-weight: 700;
    font-style: normal;
  }
  .vertical_m {
    vertical-align: middle;
  }
  .c_white {
    color: #fff !important;
  }
  .mt5 {
    margin-top: 5px;
  }
  .mt15 {
    margin-top: 15px;
  }
  .mt10 {
    margin-top: 10px;
  }
  .mt30 {
    margin-top: 30px;
  }
`;

export const popupWrapper = css`
  width: 90vw;
  border-radius: 6px;
  overflow: hidden;
  text-align: center;
  background-color: #fff;
  max-width: 400px;
  letter-spacing: -0.3px;
  p {
    margin: 0;
    padding: 0;
    list-style: none;
    line-height: 18px;
  }

  li {
    margin: unset;
    padding: unset;
    border: unset;
    vertical-align: unset;
  }
  .popupHeader {
    width: 100%;
    font-size: 18px;
    padding-top: 40px;
  }

  .popupBody {
    padding: 20px 30px 30px;
    width: 100%;
    .popupContent {
      padding: 16px;
      font-size: 14px;
      border: 1px solid #f1f1f1;
      border-radius: 5px;
      text-align: left;
      ul {
        margin: 0;
        padding: 0;
        list-style: none;
      }
      li {
        display: flex;
        align-items: center;
        font-size: 14px;
        margin-left: -4px;
        &:before {
          content: '•';
          font-size: 21px;
          color: #333333;
          opacity: 0.4;
          margin-right: 4px;
        }
        &.necessary {
          &::after {
            content: '필수';
            font-size: 10px;
            border: 1px solid #ff6900;
            color: #ff6900;
            border-radius: 9px;
            padding: 1px 8px;
            margin-left: 8px;
            flex-shrink: 0;
          }
        }
        &.optional {
          &::after {
            content: '선택';
            font-size: 10px;
            border: 1px solid #3c2dff;
            color: #3c2dff;
            border-radius: 9px;
            padding: 0 8px 1px;
            margin-left: 8px;
            flex-shrink: 0;
          }
        }

        & > span {
          color: #979797;

          &::before {
            content: ':';
            font-size: 14px;
            color: #979797;
            margin: 0 8px;
          }
        }
      }
    }
    .mt16 {
      margin-top: 16px !important;
    }
  }
  .popupFooter {
    width: 100%;
    background-color: #fff;
    border-top: 1px solid #f1f1f1;
    padding: 17px 0;
    font-size: 16px;
  }
`;

export const appInducePopUpStyle = css`
  position: relative;
  display: flex;
  flex-direction: column;
  text-align: center;
  background-color: ${palette.white};
  padding: 1em 1em 1.5em 1em;
  line-height: 1.5;
  z-index: 9;

  .close-btn {
    align-self: flex-end;
  }

  button:not(:first-of-type) {
    margin-top: 0.5em;
  }
`;

export const appInducePopUpTextStyle = css`
  margin-bottom: 1em;
  font-weight: 700;

  & > div:first-of-type {
    color: ${palette.orange9};
  }
`;
